import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Użytkownicy'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Klienci'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Grupy robocze'
, [ TEXT.UI_MENU_JOBS          ]: 'Zadania'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'System klucza głównego'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Stwórz'
, [ TEXT.UI_BUTTON_NEW         ]: 'Nowy'
, [ TEXT.UI_BUTTON_OK          ]: 'Dobrze'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Anulować'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Zapisać'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Zaloguj Się'
, [ TEXT.UI_BUTTON_SEND        ]: 'Wysłać'


, [ TEXT.UI_EMAIL              ]: 'E-mail'
, [ TEXT.UI_ROLE               ]: 'Rola'
, [ TEXT.UI_USERNAME           ]: 'Użytkownik'
, [ TEXT.UI_NAME               ]: 'Imię'
, [ TEXT.UI_DATE               ]: 'Data'
, [ TEXT.UI_ADDR               ]: 'Adres'
, [ TEXT.UI_DESC               ]: 'Opis'
, [ TEXT.UI_PRICE              ]: 'Cena'
, [ TEXT.UI_NO_DATA            ]: 'Brak danych'
, [ TEXT.UI_MACHINES           ]: 'Maszyny'
, [ TEXT.UI_USERS              ]: 'Użytkownicy'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Wyloguj'
, [ TEXT.UI_MKS_TYPE           ]: 'typ systemu klucza głównego'
, [ TEXT.UI_KEY_APP            ]: 'Użycie klucza'
, [ TEXT.UI_CLIENT             ]: 'Klient'
, [ TEXT.UI_FILE               ]: 'Karta'
, [ TEXT.UI_SELECT_FILE        ]: 'Wybierz kartę'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Nazwa Użytkownika'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Chmura'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Hasło'



, [ TEXT.ARE_YOU_SURE          ]: 'Jesteś pewny?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Niewłaściwy użytkownik / chmura lub hasło'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Niewłaściwy użytkownik / chmura lub hasło'
, [ TEXT.ERROR_INTERNAL        ]: 'Wewnętrzny błąd serwera'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Brak dostępu'
, [ TEXT.ERROR_UNKNOWN         ]: 'Wystąpił błąd i to wszystko, co wiemy'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Strona nie znaleziona'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Nowa grupa robocza'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Edytuj grupę roboczą'
, [ TEXT.WORKGROUPS_NAME       ]: 'Imię'


, [ TEXT.USERS_NEW_TITLE       ]: 'Nowy użytkownik'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Edytuj użytkownika'


, [ TEXT.MACHINE_TYPE          ]: 'Typ maszyny'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# Zadania'
, [ TEXT.MACHINE_NAME          ]: 'Maszyna'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Nowy klient'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Edytuj klienta'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adres'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontakt'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'E-mail'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefon'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Faks/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Nazwisko'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Urodziny'
, [ TEXT.CLIENT_NOTES          ]: 'Notatki'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Nazwa filtra'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filtruj adres'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtruj kontakt'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adres'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Miasto'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Województwo'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Kod pocztowy'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Kraj'


, [ TEXT.MACHINES_NEW          ]: 'Nowa maszyna'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Numer seryjny'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Edytuj zadanie'
, [ TEXT.JOB_NEW_TITLE         ]: 'Nowe zadanie'
, [ TEXT.JOB_KEY_TYPE          ]: 'Typ klucza'
, [ TEXT.JOB_NUM_KEYS          ]: 'Ilość'
, [ TEXT.JOB_MACHINE           ]: 'Maszyna'
, [ TEXT.JOB_STATUS            ]: 'Status'
, [ TEXT.JOB_DATE              ]: 'Data'
, [ TEXT.JOB_QUANTITY          ]: 'Nowa kwota'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtruj status'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtruj klientów'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtruj maszynę'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtruj typ klucza'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtruj datę'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Uruchomić'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Uruchomić ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Wgrać system klucza głównego'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: 'Zostanie utworzonych {num} kluczy. Jesteś pewny?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: 'Utworzono {num} zadań'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Nazwa systemu klucza głównego'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Zapomniałeś hasła?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Wysłałem instrukcje dotyczące odpoczynku do'
, [ TEXT.LOGIN_SLOGAN                   ]: 'Pierwsza aplikacja do kopiowania kluczy w chmurze'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Zapisz duplikaty wykonane dla klientów</li>
  <br>
  <li>Przechowuj dane bezpiecznie i z dostępem z dowolnego miejsca</li>
  <br>
  <li>Automatyczna aktualizacja</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Informacja prawna'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Polityka prywatności'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Model umowy'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/pl/legal_notice_pl.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/pl/privacy_policy_pl.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/pl/model_pl.docx'

, [ TEXT.KEY_MODEL                   ]: 'Klucze'
, [ TEXT.KEY_SERIES                  ]: 'Seria'
, [ TEXT.KEY_CODE                    ]: 'Kod'
, [ TEXT.KEY_DATA_SHEET              ]: 'Karta'
, [ TEXT.KEY_BITING                  ]: 'Gryzienie'
, [ TEXT.KEY_APPLICATION             ]: 'Podanie'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'W OCZEKIWANIU'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'ANULOWANY'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'KOMPLETNY'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'PRZETWARZANIE'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'AUTO'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'DOM'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'BEZPIECZEŃSTWO'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'KŁÓDKA'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'NIESPECYFIKOWANE'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Proszę wypełnić obowiązkowe pola na czerwono'
}

export default ES ;
